var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import selectn from "selectn";
import qs from "qs";

import TopStories from "dashboard/components/TopStories";
import { getStoriesStream, loadRevision, loadLatest, setStoryStream } from "actions/storiesStream";
import { getLocalItem } from "utils/localdb";

var StoryPermalink = function (_React$Component) {
  _inherits(StoryPermalink, _React$Component);

  function StoryPermalink(props) {
    _classCallCheck(this, StoryPermalink);

    var _this = _possibleConstructorReturn(this, (StoryPermalink.__proto__ || Object.getPrototypeOf(StoryPermalink)).call(this, props));

    _this.loadNextPage = _this._loadNextPage.bind(_this);
    return _this;
  }

  _createClass(StoryPermalink, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var params = qs.parse(this.props.location.search.slice(1));
      if (!this.props.stream.results.length || params.preview) {
        this.loadStream(this.props);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.match.params.id !== nextProps.match.params.id || this.props.stream.results.length && !nextProps.stream.results.length) {
        this.loadStream(nextProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.stream.results && this.props.stream.results.length) {
        this.props.setStoryStream([]);
      }
    }
  }, {
    key: "getStreamParams",
    value: function getStreamParams(props) {
      return { story: props.match.params.id };
    }
  }, {
    key: "loadStream",
    value: function loadStream(props) {
      var params = qs.parse(props.location.search.slice(1));
      var adminToken = getLocalItem("adminToken");
      if (params.preview && adminToken) {
        if (params.revision) {
          return this.props.loadRevision(props.match.params.id, params.revision, adminToken);
        } else {
          return this.props.loadLatest(props.match.params.id, adminToken);
        }
      }

      return this.props.getStoriesStream(this.getStreamParams(props));
    }
  }, {
    key: "_loadNextPage",
    value: function _loadNextPage(page) {
      return this.props.getStoriesStream(_extends({
        page: page
      }, this.getStreamParams(this.props)), true);
    }
  }, {
    key: "render",
    value: function render() {
      var story = this.props.stream.results[0];
      if (!story) return React.createElement(TopStories, null);

      var ogImage = selectn("social_image.crops.16x9.url", story) || selectn("primary_image.crops.16x9.url", story);
      var primaryTag = selectn("primary_tag.name", story);
      var additionalTags = story.tags.map(function (tag) {
        return tag.name;
      });
      // stories converted from RM may not have primary tag
      var tagsForMeta = primaryTag ? [primaryTag].concat(_toConsumableArray(additionalTags)).join(", ") : additionalTags.join(", ");

      return React.createElement(
        "div",
        null,
        React.createElement(
          Helmet,
          null,
          React.createElement(
            "title",
            null,
            story.headline,
            " -\xA0Axios"
          ),
          React.createElement("meta", { property: "og:url", content: story.permalink }),
          React.createElement("link", { rel: "canonical", href: story.permalink }),
          React.createElement("meta", { property: "og:title", content: story.og_headline || story.headline }),
          story.og_description && React.createElement("meta", { property: "og:description", content: story.og_description }),
          story.og_description && React.createElement("meta", { name: "description", content: story.og_description }),
          ogImage && React.createElement("meta", { property: "og:image", content: ogImage }),
          tagsForMeta && React.createElement("meta", { name: "keywords", content: tagsForMeta })
        ),
        React.createElement(TopStories, {
          permalinkId: this.props.match.params.id,
          loadNextPage: this.loadNextPage,
          onlyShowSectionForA11y: true
        })
      );
    }
  }]);

  return StoryPermalink;
}(React.Component);

StoryPermalink.propTypes = {
  stream: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.shape({
      headline: PropTypes.string.isRequired,
      permalink: PropTypes.string.isRequired,
      og_description: PropTypes.string,
      og_image: PropTypes.object,
      primary_image: PropTypes.object,
      primary_tag: PropTypes.object,
      tags: PropTypes.arrayOf(PropTypes.object)
    })).isRequired
  }),
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    })
  }),
  getStoriesStream: PropTypes.func.isRequired,
  loadLatest: PropTypes.func,
  loadRevision: PropTypes.func
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    stream: state.storiesStream
  };
};

var mapDispatchToProps = {
  getStoriesStream: getStoriesStream,
  loadLatest: loadLatest,
  loadRevision: loadRevision,
  setStoryStream: setStoryStream
};

export default connect(mapStateToProps, mapDispatchToProps)(StoryPermalink);


// WEBPACK FOOTER //
// ./src/dashboard/containers/StoryPermalink/StoryPermalink.js